import { Tag } from "lucide-react";
import { Button } from "../ui/button";

// Feb-2026 (User-Wunsch P2) — Neufahrzeug-Inkonsistenz-Warndialog, ausgelagert
// aus CreateListingPage.jsx. Erscheint, wenn Zustand „Neufahrzeug" mit km > 0
// oder Vorbesitzer > 0 widersprüchlich ist.
export default function NeuInconsistencyDialog({ form, onCancel, onConfirm }) {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4" data-testid="neu-inconsistency-dialog">
            <div className="bg-white rounded-sm max-w-md w-full p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center gap-2 mb-3">
                    <Tag className="w-5 h-5 text-amber-500" />
                    <h3 className="font-display font-black text-lg">Inkonsistenz bei „Neufahrzeug"</h3>
                </div>
                <p className="text-sm text-gray-700 mb-2">
                    Du hast den Zustand <span className="font-bold">„Neufahrzeug"</span> gewählt, aber:
                </p>
                <ul className="text-sm text-gray-700 mb-4 list-disc pl-5 space-y-1">
                    {(parseInt(form.mileage, 10) || 0) > 0 && (
                        <li data-testid="neu-warn-mileage">Kilometerstand: <span className="font-bold">{form.mileage} km</span> (sollte 0 sein)</li>
                    )}
                    {(parseInt(form.previous_owners, 10) || 0) > 0 && (
                        <li data-testid="neu-warn-owners">Vorbesitzer: <span className="font-bold">{form.previous_owners}</span> (sollte 0 sein)</li>
                    )}
                </ul>
                <p className="text-xs text-gray-500 mb-5">
                    Bei einem Neufahrzeug sind Kilometerstand und Vorbesitzer üblicherweise 0. Bitte prüfe die Angaben.
                </p>
                <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
                    <Button type="button" variant="outline" className="rounded-sm" onClick={onCancel} data-testid="neu-warn-cancel">
                        Zurück &amp; korrigieren
                    </Button>
                    <Button
                        type="button"
                        className="rounded-sm bg-amber-500 hover:bg-amber-600 text-white font-bold"
                        onClick={onConfirm}
                        data-testid="neu-warn-confirm"
                    >
                        Trotzdem veröffentlichen
                    </Button>
                </div>
            </div>
        </div>
    );
}
